import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";

import { ClientAddRoute } from "../components/Client/ClientAdd";
import { ClientDetailsRoute } from "../components/Client/ClientDetails";
import { ClientEditRoute } from "../components/Client/ClientEdit";
import { ClientSessionsRoute } from "../components/Client/ClientSessions";
import ClientsListing from "../components/Client/ClientsListings";

// Do NOT inline these components! https://stackoverflow.com/questions/70531948/how-to-determine-if-a-component-has-been-remounted
const Listing = withRouter(ClientsListing);
const Add = withRouter(ClientAddRoute);
const Edit = withRouter(ClientEditRoute);
const Sessions = withRouter(ClientSessionsRoute);
const Detail = withRouter(ClientDetailsRoute);

export default function ClientsComponent() {
  return (
    <div id="Clients">
      <React.StrictMode>
        <Switch>
          <Route exact path="/clients" component={Listing} />
          <Route exact path="/clients/add" component={Add} />
          <Route exact path="/clients/edit/:id" component={Edit} />
          <Route exact path="/clients/sessions/:id" component={Sessions} />
          <Route exact path="/clients/:id" component={Detail} />
        </Switch>
      </React.StrictMode>
    </div>
  );
}
